import * as SlotFamilyType from '../constants/SlotFamilyType';

import slotFamiliesConfig from './slot-families-config.json';

export default function slotFamilyProvider(sportId, groupType, slotType) {
    //slotType => slotFamily
    let slotFamilies = slotFamiliesConfig[sportId][groupType];

    if (slotFamilies === undefined) {
        return SlotFamilyType.SINGLE_OUTCOME;
    }

    return slotFamilies[slotType] || SlotFamilyType.SINGLE_OUTCOME;
}


// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/providers/SlotFamilyProvider.js